import { useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { VariantImage } from '@app/components/various/Matrix/MatrixContents/VariantImage';
import { VariantInfo } from '@app/components/various/Matrix/MatrixContents/VariantInfo';
import { isDefined } from '@app/utils/is';
import { Product } from '@typings';

import { ConfigurationVariantCells } from './ConfigurationVariantCells';

interface Props {
  variant: Product.Standard | Product.Full;
  rowIndex: number;
  shouldShowRrp?: boolean;
  rowSpan?: number;
}

export const VariantBodyCells = ({ variant, rowIndex, shouldShowRrp, rowSpan }: Props) => {
  const { productConfiguration } = useMatrixSettingsContext();

  const hasProductConfiguration = isDefined(productConfiguration);

  return (
    <>
      {hasProductConfiguration ?
        <ConfigurationVariantCells productConfiguration={productConfiguration} rowIndex={rowIndex} rowSpan={rowSpan} />
      : <th className="align-top" rowSpan={rowSpan}>
          <VariantImage variant={variant} className="mr-4" />
        </th>
      }
      <th className="min-w-32 py-0 pr-4 text-start align-top" rowSpan={rowSpan}>
        <VariantInfo variant={variant} shouldShowRrp={shouldShowRrp} />
      </th>
    </>
  );
};
